import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const HERO_BG = "https://images.unsplash.com/photo-1594896733292-9a77b5809c63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGdvbGR8ZW58MHx8fHwxNzc1NTA3NjY5fDA&ixlib=rb-4.1.0&q=85&w=1920";
const LOGO_TRANSPARENT = "https://customer-assets.emergentagent.com/job_teal-gold-sites/artifacts/qn91b6v2_Logo-transparent-try3.png";

export const HeroSection = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[80vh] flex items-center justify-center overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-its-teal/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 section-container text-center py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center mb-8"
        >
          <img
            src={LOGO_TRANSPARENT}
            alt="It's IT"
            className="h-12 md:h-16 w-auto"
            style={{ mixBlendMode: 'lighten' }}
          />
          <span className="text-sm md:text-base text-its-gold-soft font-normal tracking-wide -mt-1 font-poppins">
            Vibe Coding – Smarter, Faster Web Solutions
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="heading-1 mb-6"
        >
          Websites That Work
          <span className="block text-its-gold">For Your Business</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="body-text max-w-2xl mx-auto mb-10"
        >
          We specialize in creating professional websites and content management
          systems for small businesses and non-profits. Modern solutions that
          grow with you.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Link to="/process" data-testid="hero-cta-primary" className="btn-primary">
            Start Your Project
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
          <Link to="/services" data-testid="hero-cta-secondary" className="btn-secondary">
            View Services
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
